/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ComponentFactoryResolver, ComponentRef, Injectable, Renderer2 } from '@angular/core';
import { Events } from 'ag-grid-community';
// tslint:disable-next-line:no-submodule-imports
import { ProcessRowParams } from 'ag-grid-community/dist/lib/entities/gridOptions';
import { GridFeatureReadyParams } from '../feature.interfaces';
import { AbstractGridSelectBarFeature } from './abstract-grid-select-bar-feature';

import { GridRowSelectioniInitParams, GridRowSelectionsComponent } from './grid-row-selections-component';

interface SelectBarConfig {
  componentRef: ComponentRef<GridRowSelectionsComponent>;
  row: GridRowSelectioniInitParams;
}

@Injectable()
export class GridSelectBarFeature extends AbstractGridSelectBarFeature {
  private selectBars: { [id: string]: Maybe<SelectBarConfig> } = {};

  constructor(protected resolver: ComponentFactoryResolver,
              protected renderer: Renderer2) {
    super();
  }

  onGridReady(params: GridFeatureReadyParams): void {
    super.onGridReady(params);
  }

  process<C extends GridRowSelectionsComponent>(params: ProcessRowParams): void {
    if (!params.eRow) {
      return;
    }

    this.createAndAttachComponent(params);

    params.addRenderedRowListener(Events.EVENT_VIRTUAL_ROW_REMOVED, () => {
      this.detachAndDestroyComponent(params);
    });
  }

  private createAndAttachComponent<C extends GridRowSelectionsComponent>(row: GridRowSelectioniInitParams): void {
    const component = this.selectBars[row.node.id];
    if (component) {
      this.detachAndDestroyComponent(row);
    }
    const componentRef = this.createComponent();
    this.attachComponent(row, componentRef);

    this.selectBars[row.node.id] = { row, componentRef };
  }

  private detachAndDestroyComponent(row: GridRowSelectioniInitParams): void {
    this.detachComponent(row);

    const selectBar = this.selectBars[row.node.id];

    if (selectBar) {
      selectBar.componentRef.destroy();
      this.selectBars[row.node.id] = void 0;
    }
  }

}
